import React, {useState, useContext, useEffect, useRef} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import styled from "styled-components";
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MuiList from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { UsersContext } from '../../../context/users-context';
import * as EquipWorker from '../../../workers/equipWorker'
import { EquipLogContext } from '../../../context/equipLog-context';
import { parseLocalString, getUSFullDate, getUSFullTime } from '../../../utilities/utils'
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { LinearProgress } from '@material-ui/core';
import RefreshIcon from "@mui/icons-material/Refresh";
import { CurrentEquipContext } from '../../../context/currentEquip-context';
import { AllEquipsContext } from '../../../context/allEquips-context';
import Select from '@material-ui/core/Select';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import InputLabel  from '@material-ui/core/InputLabel';
import ErrorIcon from '@mui/icons-material/Error';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CircleOutlined from '@mui/icons-material/CircleOutlined';

import {
	compose,
	spacing,
	palette,
	styleFunctionSx
  } from "@material-ui/system";
    
  const styleFunction = styleFunctionSx(compose(spacing, palette));
  const List = styled(MuiList)(styleFunction);

const useStyles = makeStyles((theme) => ({
	root: {
		position: "relative",
		width: "100%",
		display: "flex",
		flexDirection: "column",
	},
	commonSpacing: {
		/*marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),*/
		margin: theme.spacing(1)
	},

	logsArea: {
		width: "100%",
		borderColor: "darkgray",
		height: "400px",
		overflowY: "auto",
		position: 'relative',
		paddingBottom: theme.spacing(1),
		paddingTop: theme.spacing(1),
	},
	logClass: {
		textAlign: "left",
	},
	speedTestWrapper: {
		padding: theme.spacing(1),
		boxShadow: "0 0 0 1px grey",
		marginBottom: theme.spacing(1),
	},
	card: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
		position: "relative",
	},
	cardContent: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		paddingBottom: theme.spacing(3),
	},
	cardRow: {
		display: "flex",
    justifyContent: "space-around",
    alignItems: "center"
	},
	cardColumn: {
		display: "flex",
    justifyContent: "space-around",
		flexDirection: "column",
    alignItems: "top"
	},
	downloadSpeed: {
		display: "flex",
		flexDirection: "column",
		width: 200,
	},
	uploadSpeed: {
		display: "flex",
		flexDirection: "column",
		width: 200,
	},
	speedTestStartButton: {
		display: "flex",
		flexDirection: "column",
		width: 250,
	},
	speedValue: {
		fontSize: "1.25em",
	},
	loader: {
		position: "absolute",
		bottom: 0,
		width: "100%",
		opacity: 0,
		transition: "opacity 0.3s",
		"&.visible": {
			opacity: 1,
		},
  },
  buttonText: {
    height: "20px"
  }
}));

const /* A component that is used to display logs. */
SummaryLogsTabPanel = React.memo((props) => {
	// export default function StandCard() {
	// export default function SummaryLogsTabPanel(props) {
	console.log("render SummaryLogsTabPanel");

	const classes = useStyles();
	const [usersState, usersDispatch] = useContext(UsersContext);
	const [equipLogs, equipLogsDispatch] = useContext(EquipLogContext);
	const [currEquipState, currEquipDispatch] = useContext(CurrentEquipContext);
	const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);
 	const equipName = props.equipName;
	const isEquipConnected = allEquipsState.connectedEquips?.includes(equipName);
	const token = usersState.token;
	const defaultDuration = 30;
	const defaultDurationUnit = 'second';
	const allDevices = 100;
	const [generatorLogs, setGeneratorLogs] = useState(false);
	const [standLogs, setStandLogs] = useState(false);
	const [detectorLogs, setDetectorLogs] = useState(false);
	const [atlasLogsOn, setAtlasLogsOn] = useState(false);
	const [duration, setDuration] = useState(defaultDuration);
	const [logDuration, setLogDuration] = useState(defaultDuration);
	const [durationUnit, setDurationUnit] = useState(defaultDurationUnit);
	const [device, setDevice] = useState(allDevices);
	const [speed, setSpeed] = useState({
		download: 0,
		upload: 0,
		units: "Mbps",
		inProcess: false,
	});

	const listRef = useRef();

	const [atlasLogs, setAtlasLogs] = useState([]); 
	const [startDate, setStartDate] = useState(getUSFullDate(new Date()));
    const [startTime, setStartTime] = useState(getUSFullTime(new Date()));
 	const [logFile, setLogFile] = React.useState('Logs\\acquisition.log');
	const [inProcess, setInProcess] = useState(false);

	const LogLevels =
	{
	  Info: 0,
	  Error: 1,
	  Warning: 2
	}

	var deviceTypes = {
		0: "None",
		1: "Generator",
		2: "Detector",
		3: "Stand",
		4: "Collimator",
		5: "ECP",
		6: "Dosimeter",
		7: "UPS",
		8: "Display"
	  };

	const onGeneratorLogs = async (event) => {
		const value = !generatorLogs;
		setGeneratorLogs(value);
	};

	const onStandLogs = async (event) => {
		const value = !standLogs;
		setStandLogs(value);
	};

	const onDetectorLogs = async (event) => {
		const value = !detectorLogs;
		setDetectorLogs(value);
	};

	const onAtlasLogs = async (event) => {
		const value = !atlasLogsOn;
		setAtlasLogsOn(value);
	};

	const onStart = async () => {
		const equipTypes = [];
		if (generatorLogs) {
			equipTypes.push("generator");
		}

		if (standLogs) {
			equipTypes.push("stand");
		}

		if (detectorLogs) {
			equipTypes.push("detector");
		}

		if (atlasLogsOn) {
			equipTypes.push("atlas");
		}

		if (!duration) {
			setDuration(defaultDuration);
		}

		const result = await EquipWorker.SetEquipLogsOn(
			token,
			equipName,
			equipTypes,
			duration ?? defaultDuration
		);
	};

	const onReset = async () => {
		equipLogsDispatch({ type: "RESETLOG", payload: true });
	};

	const showAtlasLog = async () => {
		setInProcess(true);
		let strStartDateTime = startDate + " " + (startTime.length === 7 ? "0" + startTime : startTime);

		const result = await EquipWorker.GetAtlasLogs(
			token,
			equipName,
			logFile,
			strStartDateTime,
			logDuration ?? defaultDuration,
			durationUnit
		);
	};

	const onDurationChange = async (event) => {
		const val = event.target.value;
		setDuration(!isNaN(val) || val === "" ? val : defaultDuration);
	};

	const handleStartDateChange = (ev) => {
		setStartDate(ev.target.value);
	   };

	  const handleStartTimeChange = (ev) => {
		setStartTime(ev.target.value);
	  };
	  const handleLogChange = (event) => {
		setLogFile(event.target.value);
	  };

	  const onLogDurationChange = async (event) => {
		const val = event.target.value;
		setLogDuration(!isNaN(val) || val === "" ? val : defaultDuration);
	};

	const onDurationUnitChange = async (event) => {
		const val = event.target.value;
		setDurationUnit(val);
	};

	const onDeviceChange = async (event) => {
		const val = event.target.value;
		setDevice(val);
	};
	//debug code////////////////////////
	function resolveAfter5Seconds(x) {
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve(x);
			}, 2500);
		});
	}
	///////////////////////////////////
	useEffect(() => {
		(async () => {
			let download = currEquipState.remoteaccess?.SpeedTestResult?.Item1;
			let upload = currEquipState.remoteaccess?.SpeedTestResult?.Item2;

			setSpeed({
				download: download,
				upload: upload,
				units: "Mbps",
				inProcess: false,
			});		

		})();
	  }, [currEquipState.remoteaccess?.SpeedTestResult]);

	const speedTestRun = async () => {
		setSpeed((prev) => ({
			...prev,
			download: 0,
			upload: 0,
			inProcess: true,
		}));

		var res = await EquipWorker.GetNetworkSpeed(token, equipName);		
	};

	useEffect(() => {
		(async () => {
			let atlsLogs = currEquipState.remoteaccess?.AtlasLogs;
			if (atlsLogs !== undefined)
				setAtlasLogs(atlsLogs);
		})();

		setInProcess(false);
	  }, [currEquipState.remoteaccess?.AtlasLogs]);

	  useEffect(() => { 
		listRef.current?.scrollTo(0, 0);
	  }, [device]);

	  useEffect(() => { 
		  listRef.current?.scrollTo(0, 0);
	  }, [atlasLogs]);

	  useEffect(() => {
		setDevice(allDevices);
		setAtlasLogs([]);
	  }, [logFile]);

	// const newLog = equipLogs.currentLog?.Type + ' ' + equipLogs.currentLog?.State?.Timestamp + ' ' + equipLogs.currentLog?.State?.Data;
	const logs = equipLogs?.currentLogs;
	const atlasVersion = currEquipState.locationInfo?.AtlasVersion ?? "";
	const isOldLogsVersion = atlasVersion.localeCompare("1.2.23.1", undefined, { numeric: true, sensitivity: 'base' }) < 0;
	return (
		<div className={classes.root}>
			<Card className={classes.card}>
				<CardContent className={classes.cardContent}>
					<div className={classes.cardRow}>
						<div className={classes.downloadSpeed}>
							<Typography variant="h6">Скорость скачки</Typography>
							<div className={classes.speedValue}>{`${speed.download || "-"} ${
								speed.units
							}`}</div>
						</div>
						<div className={classes.uploadSpeed}>
							<Typography variant="h6">Скорость загрузки</Typography>
							<div className={classes.speedValue}>{`${speed.upload || "-"} ${
								speed.units
							}`}</div>
						</div>
						<div className={classes.speedTestStartButton}>
							<Button
								variant="contained"
								color="primary"
								onClick={speedTestRun}
								disabled={!isEquipConnected || speed.inProcess}
								startIcon={<RefreshIcon />}>
								<div className={classes.buttonText}>Скорость соединения</div>
							</Button>
						</div>
					</div>
				</CardContent>
				<div>
					<LinearProgress
						className={`${classes.loader} ${
							speed.inProcess ? "visible" : ""
						}`}></LinearProgress>
				</div>
			</Card>
			<Card  className={classes.card} name="devices-logs-control">
				<CardContent  className={classes.cardContent}>
					<div className={classes.cardColumn}>
						<div>
						<FormControlLabel
							control={
								<Checkbox checked={generatorLogs} onChange={onGeneratorLogs} />
							}
							label="Логи генератора"
						/>
						<FormControlLabel
							control={
								<Checkbox checked={detectorLogs} onChange={onDetectorLogs} />
							}
							label="Логи детектора"
						/>

						<TextField
							id="outlined-basic"
							className={classes.commonSpacing}
							value={duration}
							onChange={onDurationChange}
							label="Длительность, сек"
							variant="outlined"
						/>

						<Button
							variant="contained"
							color="primary"
							className={classes.commonSpacing}
							onClick={onStart}
							disabled={!isEquipConnected}>
							Запустить
						</Button>

						<Button
							variant="contained"
							color="primary"
							className={classes.commonSpacing}
							onClick={onReset}>
							Очистить
						</Button>

						</div>
						
						<List sx={{ 
							width: '100%', 
							height: 300, 
							bgcolor: 'gray',  
							position: 'relative', 
							overflow: 'auto' }}>
							{logs?.map((log, ind) => (
								<ListItem>
									<ListItemText
									key={log?.State?.Timestamp.toString()}
									primary={
										parseLocalString(log?.State?.Timestamp ?? log?.Timestamp) +
										" " +
										log?.Type +
										" " +
										log?.State?.Source +
										" " +
										(log?.State?.Data ?? log?.Data)
									}
								/>
								</ListItem>
								
							))}
						</List>
					</div>
				</CardContent>
			</Card>

			<Card  className={classes.card} name="atlas-logs-control">
				<CardContent  className={classes.cardContent}>
					<div className={classes.cardColumn}>
						<div className={classes.cardRow}>
						
						<FormControl 
						style={{minWidth: 180, textAlign: "left"}}
						  variant="standard">
						<InputLabel>Название</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={logFile}
								label="Логи"
								labelWidth="10"
								onChange={handleLogChange}
							>
								<MenuItem value={'acquisition.log'}>Acquisition</MenuItem>
								{isOldLogsVersion ?
								<MenuItem value={'aprloader.log'}>Aprloader</MenuItem> : null
								}
								<MenuItem value={'auth.log'}>Auth</MenuItem>
								<MenuItem value={'backup.log'}>Backup</MenuItem>
								<MenuItem value={'burn.log'}>Burning</MenuItem>
								<MenuItem value={'hrlogs.log'}>Common</MenuItem>
								<MenuItem value={'comm.log'}>Communication</MenuItem>
								<MenuItem value={'hardware.log'}>Hardware</MenuItem>
								<MenuItem value={'settings.log'}>Settings</MenuItem>
								<MenuItem value={'journal.log'}>Journal</MenuItem>
								<MenuItem value={'statreports.log'}>StatReports</MenuItem>
								<MenuItem value={'others.log'}>WhatEver</MenuItem>
								{isOldLogsVersion ?
								<>
								<MenuItem value={'MainProcess.log'}>MainProcess</MenuItem>
								<MenuItem value={'RendererProcess.log'}>RendererProcess</MenuItem>
								</> :
								<MenuItem value={'atlasUI.log'}>AtlasUI</MenuItem>
								}
								<MenuItem value={'msgSender.log'}>Client</MenuItem>
							</Select>
						</FormControl>

						<FormControl

						variant="standard"
						style = {{width: 160, textAlign: "left"}}>
							<InputLabel>Устройство</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={device}
								label="Устройство"
								onChange={onDeviceChange}
								disabled={logFile !== 'hardware.log'}
							>
								<MenuItem value={allDevices}>All</MenuItem>
								<MenuItem value={0}>Atlas</MenuItem>
								<MenuItem value={1}>Generator</MenuItem>
								<MenuItem value={3}>Stand</MenuItem>
								<MenuItem value={2}>Detector</MenuItem>
								<MenuItem value={4}>Collimator</MenuItem>
								<MenuItem value={5}>ECP</MenuItem>
								<MenuItem value={6}>Dosimeter</MenuItem>
								<MenuItem value={7}>UPS</MenuItem>
								<MenuItem value={8}>Display</MenuItem>
							</Select>
						</FormControl>


						<div className={classes.cardColumn}>
							<TextField
								id="startDate"
								label="Дата"
								type="date"
								variant="standard"
								defaultValue={startDate}
								onChange={handleStartDateChange}
								className={classes.textField, classes.commonSpacing}
								InputLabelProps={{
								shrink: true,
								}}
							/>
							<TextField
								id="startTime"
								label="Время"
								type="time"
								step="1"
								variant="standard"
								defaultValue={startTime}
								onChange={handleStartTimeChange}
								className={classes.textField, classes.commonSpacing}
								InputLabelProps={{
								shrink: true,
								}}
							/>
						</div>
						
						<TextField
							id="outlined-basic"
							className={classes.commonSpacing}
							value={logDuration}
							onChange={onLogDurationChange}
							label="Длительность"
							variant="standard"
							style = {{width: 160}}
						>
						</TextField>
						<FormControl
						variant="standard"
						style = {{width: 160, textAlign: "left"}}>
							<InputLabel>Единица измерения</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={durationUnit}
								label="Единица измерения длительности"
								onChange={onDurationUnitChange}
							>
								<MenuItem value={'hour'}>часов</MenuItem>
								<MenuItem value={'minute'}>минут</MenuItem>
								<MenuItem value={'second'}>секунд</MenuItem>
							</Select>
						</FormControl>


						<Button
							variant="contained"
							color="primary"
							disabled={!isEquipConnected || inProcess}
							className={classes.commonSpacing}
							onClick={showAtlasLog}>
							Получить логи Atlas
						</Button>
						</div>

					<List 
					id="atlasLogsList"
					ref={listRef}
					sx={{ 
						width: '100%', 
						height: 300, 
						bgcolor: 'gray',  
						position: 'relative', 
						overflow: 'auto' }}>
					{
					atlasLogs?.filter(val => val.DeviceType == device || device === allDevices).map((value, index) => (
						<ListItem
							key={`row_${index}`}
							dense={true}
							divider={true}
						>
							{value.Type === LogLevels.Info ?
							<Tooltip title="information" arrow>
								<ListItemIcon>
									<CheckCircleOutlineIcon/>
								</ListItemIcon>
							</Tooltip>
							: value.Type === LogLevels.Error ?
							<Tooltip title="error" arrow>
								<ListItemIcon>
									<ErrorIcon />
								</ListItemIcon>
							</Tooltip>
							: value.Type === LogLevels.Warning ?
							<Tooltip title="warning" arrow>
								<ListItemIcon>
									<ReportGmailerrorredIcon/>
								</ListItemIcon>
							</Tooltip>
							: 
							<Tooltip title="other" arrow>
								<ListItemIcon>
									<CircleOutlined/>
								</ListItemIcon>
							</Tooltip>}
							<ListItemText primary={` [${value.Date}] ${value.DeviceType !== null && value.DeviceType !== 0 ? `[${deviceTypes[value.DeviceType]}]   ` : " "} ${value.Content}`} />
						</ListItem>
						))}
					</List>
					</div>
				
				</CardContent>
			</Card>
		</div>
	);
});

export default SummaryLogsTabPanel;

  